import React, { useMemo } from 'react';
import { ViewerEnvironmentContext } from './environment';
import type { ViewerEnvironment } from './environment';

export interface ModelViewerProviderProps extends ViewerEnvironment {
  children: React.ReactNode;
}

const ModelViewerProvider: React.FC<ModelViewerProviderProps> = ({
  onError,
  portalContainer,
  viewRender,
  children,
}) => {
  const value = useMemo(() => ({ onError, portalContainer, viewRender }), [onError, portalContainer, viewRender]);
  return <ViewerEnvironmentContext.Provider value={value}>{children}</ViewerEnvironmentContext.Provider>;
};

export default ModelViewerProvider;
